import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoDialogComponent } from '../../dialogs/yes-no-dialog/yes-no-dialog.component';
import { AuthorizationBase } from '../../libraries/authorize-base';
import { AlertService } from '../../../core/alert.service';
import { NotificationScheduleOption } from '../../models/settings/notification-schedule-option';
import { SubscriptionService } from '../../services/subscription-service.service';

@Component({
  selector: 'app-notification-schedule-options',
  templateUrl: './notification-schedule-options.component.html',
  styleUrls: ['./notification-schedule-options.component.scss'],
})
export class NotificationScheduleOptionsComponent
  extends AuthorizationBase
  implements OnInit
{
  @Input() moduleType: string = 'Subscription';
  public searchKey: FormControl = new FormControl();

  busy: boolean = false;
  saving: boolean;
  options: NotificationScheduleOption[] = [];
  user: any;

  constructor(
    private alert: AlertService,
    private modalService: NgbModal,
    private subscriptionService: SubscriptionService
  ) {
    super();
    this.user = this.getCurrentLoginUser();
  }

  ngOnInit() {
    this.loadLists();
  }

  loadLists() {
    this.busy = true;
    this.subscriptionService
      .getactivenotificationscheduleoption(this.moduleType)
      .subscribe(
        (res: any[]) => {
          this.busy = false;
          this.options = res;
          if (this.options.length == 0) {
            this.addField();
          }
        },
        (error: any) => {
          this.busy = false;
        },
        () => {
          this.busy = false;
        }
      );
  }

  addField() {
    if (this.options.length < 3) {
      const field = new NotificationScheduleOption();
      field.Id = 0;
      field.FrequencyType = 'Daily';
      field.FrequencyValue = 1;
      field.IsActive = true;
      field.IsDeleted = false;
      field.CreatedBy = +this.user.UserId;
      field.ModuleType = this.moduleType;
      this.options.push(field);
    }
  }

  isOptionValid(field: NotificationScheduleOption): boolean {
    if (field.saving) return false;
    return true;
  }

  removeField(field: NotificationScheduleOption) {
    if (field.Id == 0) {
      this.options.splice(this.options.indexOf(field), 1);
    } else {
      let yesNoDialog = this.modalService.open(YesNoDialogComponent, {
        size: 'sm',
        backdrop: 'static',
      });
      yesNoDialog.componentInstance.content =
        'Are you sure you want to delete this option?';
      yesNoDialog.result.then((res) => {
        if (res) {
          field.IsDeleted = true;
          field.UpdatedBy = +this.user.UserId;

          this.subscriptionService
            .upsertNotificationScheduleOption(field)
            .subscribe((res: any) => {
              this.options.splice(this.options.indexOf(field), 1);
              this.alert.alertSuccess({
                title: 'Schedule Option',
                text: 'Option has been successfully deleted.',
              });
            });
        }
      });
    }
  }

  optionChanged(field: NotificationScheduleOption) {
    if (this.isOptionValid(field)) {
      field.saving = true;
      this.subscriptionService
        .upsertNotificationScheduleOption(field)
        .subscribe((res: any) => {
          field.saving = false;
          field.Id = res;
        });
    }
  }
}
